/**
 * `/studio/tasks` — the board. The page is `pages/studio/tasks/`.
 *
 * `?view=board|list` and `?filter=all|mine|overdue` are the two segs the mockup's
 * topbar carries, and both are in the URL so a studio member can send somebody
 * "the overdue list".
 *
 * Which is the argument for `routeSearch`: an address that gets passed around by
 * hand is an address that gets mistyped, and a mistyped seg shows the board.
 */

import { createFileRoute } from '@tanstack/react-router'

import { TasksPage, TasksSearchSchema } from '../../../pages/studio/tasks/TasksPage.js'
import { routeSearch } from '../../../search/useSearchState.js'

export const Route = createFileRoute('/studio/tasks/')({
  validateSearch: routeSearch(TasksSearchSchema),
  component: TasksPage,
})
